module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/metabase-org/releases/release-2023-04-05-x.46.1/metabase-0.46.1/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/metabase-org/releases/release-2023-04-05-x.46.1/metabase-0.46.1/node_modules/source-map-loader/dist/cjs.js!/Users/metabase/code/metabase-org/releases/release-2023-04-05-x.46.1/metabase-0.46.1/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}